import * as C from "react";
import { forwardRef as o } from "react";
const n = o(function(e, t) {
  return /* @__PURE__ */ C.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ C.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M20.1211 7.89786H16.0957C16.377 7.75635 16.6231 7.59721 16.8692 7.43813C17.7305 6.81926 18.2051 6.02354 18.2051 5.22788C18.2051 4.57367 17.8887 3.99014 17.4317 3.61887C16.9922 3.21219 16.4121 3 15.7793 3C15.0938 3 14.4961 3.22983 13.9512 3.58346C13.1426 4.11394 12.5098 4.9273 12.0527 5.84676L12 5.97049C11.8418 5.61686 11.6484 5.29864 11.42 4.96264C11.0508 4.43223 10.5762 3.93709 10.0489 3.58346C9.52148 3.22983 8.8887 3 8.22072 3C7.55274 3 6.95509 3.26524 6.48046 3.70726C6.02342 4.13165 5.70707 4.75045 5.70707 5.44008C5.70707 5.86439 5.81254 6.27107 6.05863 6.66012C6.37498 7.13748 6.83202 7.56187 7.5 7.89786H3.87893C3.4043 7.89786 3 8.30454 3 8.79961V12.053H11.4902V7.89786H12.5274V12.053H21V8.79961C21 8.30454 20.6133 7.89786 20.1211 7.89786ZM4.59961 21H11.4902V13.2731H4.59961V21ZM12.5273 21H19.4004V13.2731H12.5273V21ZM7.81638 6.62476C7.46483 6.39486 7.25388 6.18267 7.13087 5.98818C7.02539 5.79369 6.97266 5.61684 6.97266 5.44006C6.97266 5.17482 7.11327 4.85653 7.34175 4.64434C7.5879 4.41451 7.92186 4.27307 8.20308 4.27307C8.60738 4.27307 8.97654 4.3968 9.3457 4.64434C9.8906 5.03338 10.4355 5.66989 10.8047 6.41257C10.998 6.78383 11.1386 7.17288 11.2266 7.57956C9.53905 7.40271 8.43163 7.01373 7.81638 6.62476ZM13.5996 5.7053C13.916 5.26321 14.2676 4.89194 14.6543 4.64434C15.0235 4.3968 15.4101 4.27307 15.7617 4.27307H15.7793C16.1133 4.27307 16.3945 4.3968 16.6054 4.57365C16.8164 4.75043 16.9219 4.98033 16.9219 5.22787C16.9219 5.51075 16.7812 5.91743 16.1133 6.39486C15.4805 6.85459 14.3906 7.33202 12.7383 7.66795C12.8965 6.99603 13.2128 6.28876 13.5996 5.7053Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  n as Gift
};
